// Use the appropriate API base URL based on the environment
export const domainNameResolver = () => {
  let url = ''; 
  switch (process.env.REACT_APP_API_CKMS_ENVIRONMENT_NAME) {
    case 'dev':
      url =  "https://apim-na.dev.mypepsico.com/cgf/ckms-api/v1/"
      break;
    case 'preprod':
      url = '"https://apim-na.preprod.mypepsico.com/cgf/ckms-api/v1';
      break;
    case 'prod':
      url = '"https://apim-na.prod.mypepsico.com/cgf/ckms-api/v1';
      break;
    default:
      url = "https://apim-na.mypepsico.com/cgf/ckms-api/v1"; // Default to localhost if not set
      break;
  }
  return url;
};

// Endpoint paths (without base URLs)
export const ENDPOINTS = {
  chat: '/api',
  upload: '/api/upload',
  restrictedUpload: '/api/upload',
  insertFormData: '/api',
  engagementHistoryData: '/api',
  userProfile: '/api/pingUser'
};
